import styled from 'styled-components/macro'

import { Layout } from '@loadsmart/loadsmart-ui'

import { screen } from 'legacy/styles/screen'

export const MoreInfoSectionWrapper = styled(Layout.Group)`
  flex-wrap: wrap;

  ${screen.md} {
    flex-wrap: unset;
  }
`

export const ColumnWrapper = styled.div`
  flex-basis: 100%;

  ${screen.md} {
    flex-basis: 33.3%;
  }
`
